/* eslint-disable linebreak-style */
import React, {useRef, useState, useEffect, useMemo} from 'react';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import Loader from 'react-loader-spinner';
import {
  Card,
} from '@material-ui/core';


import { L10n, getValue, createElement} from '@syncfusion/ej2-base';
import { Browser } from '@syncfusion/ej2-base';
import { withSnackbar } from 'notistack';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import './orderstable.css';
import expozoare from './data';
import productsData from '../../../ProductList/data';
import { dataFormatRO, verificaIndicatoriSiActualizeaza } from '../../../../utils/functiiComune';
import { buildNewOrderTemplate } from '../../../../utils/orderWorkflow';
import {strapi} from '../../../../strapi/strapi.config';
import { setOrdersSuccess, setCurrentOrder, setCurrentItem, setUpdatedOrder, setDeletedItems, setCurrentProduct, setExpoPrefill} from '../../../../redux/order/order.actions';
import { selectOrderCurrentProduct, selectOrderOrders }from '../../../../redux/order/order.selectors';
import { selectCurrentUser }from '../../../../redux/user/user.selectors';
import { selectOtherLoading}from '../../../../redux/other/other.selectors';
import {
  loadProduseStart,
  loadMaterialeStart,
  loadOptionaleStart,
  loadCuloriStart,
  loadPreturiTabelareStart,
  loadInformariStart,
  loadIndicatoriStart
} from '../../../../redux/lookup/lookup.actions';
import { t } from '../../../../i18n';

L10n.load({
  'ro-RO': {
    'grid': {
      'Add': t('ordersTable.add'),
      'Edit': t('ordersTable.edit'),
      'Delete': t('ordersTable.delete'),
      'Update': t('ordersTable.update'),
      'Cancel': t('ordersTable.cancel'),
      'Save': t('ordersTable.save'),
      'Item': t('ordersTable.item'),
      'Items': t('ordersTable.items'),
      'EmptyRecord': t('ordersTable.emptyRecord'),
      'EditOperationAlert': t('ordersTable.editOperationAlert'),
      'DeleteOperationAlert': t('ordersTable.deleteOperationAlert'),
      'SaveButton': t('ordersTable.saveButton'),
      'CancelButton': t('ordersTable.cancelButton'),
      'ConfirmDelete': t('ordersTable.confirmDelete'),
      'CancelEdit': t('ordersTable.cancelEdit')
    },
    'pager':{
      'currentPageInfo': t('ordersTable.pagerCurrent'),
      'firstPageTooltip': t('ordersTable.pagerFirst'),
      'lastPageTooltip': t('ordersTable.pagerLast'),
      'nextPageTooltip': t('ordersTable.pagerNext'),
      'nextPagerTooltip': t('ordersTable.pagerNext'),
      'previousPageTooltip': t('ordersTable.pagerPrevious'),
      'previousPagerTooltip': t('ordersTable.pagerPrevious'),
      'totalItemsInfo': t('ordersTable.pagerTotal')
    }
  }
}); 

const useStyles = makeStyles(() => ({
  gridContainer: {
    height: '100%', // Ocupă întreaga înălțime a containerului părinte
    display: 'flex',
    flexDirection: 'column'
  },
  spinner:{
    textAlign: 'center',
    padding:'200px'
  },
  netransmisa:{
    color:'orange'
  }
}));

const ExpozorTable = props => {
  const { currentUser,currentProduct,history,setOrdersSuccess,setCurrentOrder, loading, setCurrentItem, setUpdatedOrder, orders, setDeletedItems, enqueueSnackbar, setCurrentProduct, setExpoPrefill} = props;
  
  // State pentru loading local
  const [isTableLoading, setIsTableLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [isShortcutLoading, setIsShortcutLoading] = useState(false);
  const [canScrollUp, setCanScrollUp] = useState(false);
  const [canScrollDown, setCanScrollDown] = useState(false);
  const normalizedProductCode = useMemo(
    () => (currentProduct?.cod ? String(currentProduct.cod).toLowerCase() : null),
    [currentProduct]
  );
  const carouselListRef = useRef(null);

  const availableProducts = useMemo(() => {
    if (!normalizedProductCode) {
      return expozoare;
    }
    const filtered = expozoare.filter(item => {
      if (!item.produs) {
        return true;
      }
      return String(item.produs).toLowerCase() === normalizedProductCode;
    });
    return filtered.length ? filtered : expozoare;
  }, [normalizedProductCode]);

  const filteredProducts = useMemo(() => {
    if (!searchTerm.trim()) {
      return availableProducts;
    }
    const term = searchTerm.trim().toLowerCase();
    return availableProducts.filter(item =>
      Object.entries(item)
        .filter(([key, value]) => key !== 'imagine' && typeof value !== 'object')
        .some(([, value]) => String(value).toLowerCase().includes(term))
    );
  }, [availableProducts, searchTerm]);

  useEffect(() => {
    if (!filteredProducts.length) {
      setSelectedIndex(-1);
      return;
    }
    setSelectedIndex(prev => {
      if (prev < 0 || prev > filteredProducts.length - 1) {
        return 0;
      }
      return prev;
    });
  }, [filteredProducts]);

  const selectedProduct = selectedIndex >= 0 ? filteredProducts[selectedIndex] : null;

  const detailEntries = useMemo(() => {
    if (!selectedProduct) {
      return [];
    }
    const hiddenFields = ['imagine', 'produs', 'Cod', 'Tip', 'precompletare'];
    return Object.entries(selectedProduct).filter(
      ([key, value]) => !hiddenFields.includes(key) && value !== null && value !== undefined && value !== ''
    );
  }, [selectedProduct]);

  const updateScrollState = () => {
    const list = carouselListRef.current;
    if (!list) {
      setCanScrollUp(false);
      setCanScrollDown(false);
      return;
    }
    setCanScrollUp(list.scrollTop > 0);
    setCanScrollDown(list.scrollTop + list.clientHeight < list.scrollHeight - 1);
  };

  useEffect(() => {
    const list = carouselListRef.current;
    if (!list) {
      return undefined;
    }
    const handleScroll = () => {
      updateScrollState();
    };
    handleScroll();
    list.addEventListener('scroll', handleScroll);
    return () => {
      list.removeEventListener('scroll', handleScroll);
    };
  }, [filteredProducts]);

  useEffect(() => {
    const list = carouselListRef.current;
    if (list) {
      list.scrollTop = 0;
      updateScrollState();
    }
  }, [filteredProducts]);

  const getScrollStep = () => {
    const list = carouselListRef.current;
    if (!list) {
      return 0;
    }
    const firstItem = list.querySelector('.expo-carousel-item');
    if (!firstItem) {
      return 0;
    }
    const styles = window.getComputedStyle(firstItem);
    const marginBottom = parseFloat(styles.marginBottom || '0');
    return firstItem.offsetHeight + marginBottom;
  };

  const handleCarouselScroll = direction => {
    const list = carouselListRef.current;
    if (!list) {
      return;
    }
    const step = getScrollStep() || list.clientHeight / 2;
    const delta = direction === 'up' ? -step : step;
    list.scrollBy({
      top: delta,
      behavior: 'smooth'
    });
  };

  const handleSelectProduct = index => {
    if (index < 0 || index >= filteredProducts.length) {
      return;
    }
    setSelectedIndex(index);
  };

  const handleSearchChange = event => {
    setSearchTerm(event.target.value);
  };

  const normalizeText = value => (value || '').toString().toUpperCase().trim();

  const findProductForExpo = expoItem => {
    if (!expoItem) {
      return null;
    }
    const code = (expoItem.precompletare?.tipProdus || expoItem.produs || '').toLowerCase();
    if (!code) {
      return null;
    }
    const candidates = productsData.filter(prod => prod.cod === code);
    if (!candidates.length) {
      return null;
    }
    const desiredSubTip = normalizeText(
      expoItem.subTip || expoItem.precompletare?.subTip || expoItem.precompletare?.subtip
    );
    const scopedCandidates = desiredSubTip
      ? candidates.filter(prod => normalizeText(prod.subTip) === desiredSubTip)
      : candidates;
    if (!scopedCandidates.length) {
      return null;
    }
    const desiredName = normalizeText(expoItem.precompletare?.denumireProdus);
    if (desiredName) {
      const matchByName = scopedCandidates.find(prod => normalizeText(prod.title) === desiredName);
      if (matchByName) {
        return matchByName;
      }
    }
    return scopedCandidates[0];
  };

  const buildExpoPrefillPayload = (expoItem, product) => ({
    expo: {
      ...expoItem,
      precompletare: expoItem.precompletare
        ? JSON.parse(JSON.stringify(expoItem.precompletare))
        : null
    },
    productCode: product.cod,
    productSubTip: product.subTip || ''
  });

  const handleAddToOrder = async () => {
    const expoItem = selectedProduct;
    if (!expoItem) {
      enqueueSnackbar(t('expozor.selectFirst'), {
        variant: 'warning',
        autoHideDuration: 2000
      });
      return;
    }
    if (!currentUser?.idFirma?.id) {
      enqueueSnackbar(t('expozor.noCompany'), {
        variant: 'error',
        autoHideDuration: 3000
      });
      return;
    }
    const matchedProduct = findProductForExpo(expoItem);
    // if (!matchedProduct) {
    //   enqueueSnackbar('Produsul selectat nu figureaza inca in aplicatie. Va fi adaugat in viitorul apropiat.Pentru comenzi va rog sa ne contactati telefonic.', {
    //     variant: 'warning',
    //     autoHideDuration: 10000
    //   });
    //   return;
    // }
    if (matchedProduct.cod === 'sv') {
      enqueueSnackbar(t('expozor.noLinesAllowed'), {
        variant: 'warning',
        autoHideDuration: 3000
      });
      return;
    }
    try {
      setIsShortcutLoading(true);
      await verificaIndicatoriSiActualizeaza(currentUser.idFirma.id, props);
      setCurrentProduct(matchedProduct);
      const template = buildNewOrderTemplate(matchedProduct, currentUser);
      if (!template) {
        enqueueSnackbar(t('expozor.templateBuildError'), {
          variant: 'error',
          autoHideDuration: 3000
        });
        return;
      }
      const orderWithClient = {
        ...template,
        clientClient: template.clientClient || t('order.prefillClientPlaceholder'),
        comandarepers: [...(template.comandarepers || [])]
      };
      setCurrentOrder(orderWithClient);
      setUpdatedOrder({
        ...orderWithClient,
        comandarepers: [...orderWithClient.comandarepers]
      });
      setDeletedItems([]);
      setCurrentItem({});
      setOrdersSuccess([]);
      setExpoPrefill(buildExpoPrefillPayload(expoItem, matchedProduct));
      history.push('/order');
    } catch (error) {
      console.error('Eroare flux expozoare:', error);
      enqueueSnackbar(t('expozor.launchOrderError'), {
        variant: 'error',
        autoHideDuration: 3000
      });
    } finally {
      setIsShortcutLoading(false);
    }
  };

  const emptyStateMessage = searchTerm.trim()
    ? t('expozor.emptySearch')
    : t('expozor.emptyList');

  // Effect pentru a detecta schimbările în comenzi
  useEffect(() => {
    // Activăm loading-ul când se schimbă datele
    setIsTableLoading(true);
    
    // Dezactivăm loading-ul după un scurt delay pentru o tranziție fluidă
    const timer = setTimeout(() => {
      setIsTableLoading(false);
    }, 300);
    
    return () => clearTimeout(timer);
  }, [orders]);
  const toolbarOptions =[
    { text: 'Adauga', tooltipText: 'Adauga comanda noua', prefixIcon: 'e-add', id: 'Adauga', disabled:false },
    { text: 'Modifica', tooltipText: 'Modifica comanda selectata', prefixIcon: 'e-edit', id: 'Modifica' },
    { text: 'Sterge', tooltipText: 'Sterge comanda selectata', prefixIcon: 'e-delete', id: 'Sterge' },
  ];
  const editSettings = { allowDeleting: false, mode: 'Dialog', allowEditOnDblClick: false, showDeleteConfirmDialog: true };
  const sortingOptions = {columns: [{ field: 'id', direction: 'Descending' }]}
  const selectionsettings = {checkboxMode: 'ResetOnRowClick',type: 'Single' };
  const classes = useStyles();
  const masterGrid = useRef(null)
//----------------------------------------------------------------------------------------------------
  const filterOptions = {
    type: 'Menu',
    operators: {
      stringOperator: [
        { value: 'contains', text: 'Conține' },
        { value: 'startswith', text: 'Începe cu' },
        { value: 'endswith', text: 'Se termină cu' }
      ]
    },
    mode: 'Immediate'
  };

  //----------------------------------------------------------------------------------------------------
  
  //----------------------------------------------------------------------------------------------------
  const jsonCopy=(src)=>{
    return JSON.parse(JSON.stringify(src));
  }
  //----------------------------------------------------------------------------------------------------
  const rowselect=(args)=>{
    let selRecord = args.data;
    vizualizareComandaSetCurentOrder(selRecord)
    vizualizareComandaSetUpdatedOrder(selRecord)
  }
  //----------------------------------------------------------------------------------------------------
  const rowdeselect=()=>{
    setCurrentOrder({});
  }
  //----------------------------------------------------------------------------------------------------
  const actionBegin=(args)=> {
    if (args.requestType === 'save') {
      if (masterGrid.pageSettings.currentPage !== 1 && masterGrid.editSettings.newRowPosition === 'Top') {
        args.index = (masterGrid.pageSettings.currentPage * masterGrid.pageSettings.pageSize) - masterGrid.pageSettings.pageSize;
      }
      else if (masterGrid.editSettings.newRowPosition === 'Bottom') {
        args.index = (masterGrid.pageSettings.currentPage * masterGrid.pageSettings.pageSize) - 1;
      }
    }
  }
  //----------------------------------------------------------------------------------------------------
  const actionComplete=(args)=>{
    if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {
      if (Browser.isDevice) {
        args.dialog.height = window.innerHeight - 90 + 'px';
        args.dialog.dataBind();    
      }
    }
  }
  //----------------------------------------------------------------------------------------------------

  const currencyFormatter=(field, data)=>{
    if (currentProduct.cod==='jv' || currentProduct.cod==='ro'|| currentProduct.cod==='jo'){
      return  getValue(field, data) + ' Lei';
    }else{
      return  getValue(field, data) + ' Euro';
    }

  }
  //----------------------------------------------------------------------------------------------------
  const dateFormatter=(field, data)=>{
    return  dataFormatRO(getValue(field, data)).substring(0, 10);
  }
  //----------------------------------------------------------------------------------------------------
  const customizeCell=(args)=>{
    if((args.column).field === 'stadiu' && args.data && args.cell) {
      if (getValue('stadiu', args.data) ==='NETRANSMISA'){
        args.cell.classList.add('netransmisa');
      } 
    }
  }
  //----------------------------------------------------------------------------------------------------
  const headerCellInfo=(args)=>{ 
    args.node.getElementsByClassName('e-checkbox-wrapper')[0] && args.node.getElementsByClassName('e-checkbox-wrapper')[0].remove(); 
  } 
  //----------------------------------------------------------------------------------------------------
  const clickHandlerMaster=async e=>{
    const { setCurrentOrder,setUpdatedOrder}=props;
    //.....................................
    if (e.item.properties.id==='Adauga'){
      switch(currentProduct.cod){
        case 'jv':
          setCurrentOrder({tipProdus:currentProduct.cod,idFirma:currentUser.idFirma.id,discount:currentUser.idFirma.discountJV, id:0, comandarepers:[]})
          setUpdatedOrder({tipProdus:currentProduct.cod,idFirma:currentUser.idFirma.id,discount:currentUser.idFirma.discountJV, id:0, comandarepers:[]})
          break;
        case 'ro':
          setCurrentOrder({tipProdus:currentProduct.cod,idFirma:currentUser.idFirma.id,discount:currentUser.idFirma.discountRO, id:0, comandarepers:[]})
          setUpdatedOrder({tipProdus:currentProduct.cod,idFirma:currentUser.idFirma.id,discount:currentUser.idFirma.discountRO, id:0, comandarepers:[]})
          break;
        case 're':
          setCurrentOrder({subTip:currentProduct.subTip,tipProdus:currentProduct.cod,idFirma:currentUser.idFirma.id,discount:currentUser.idFirma.discountRE, id:0, comandarepers:[]})
          setUpdatedOrder({subTip:currentProduct.subTip,tipProdus:currentProduct.cod,idFirma:currentUser.idFirma.id,discount:currentUser.idFirma.discountRE, id:0, comandarepers:[]})
          break;
        case 'ug':
          setCurrentOrder({tipProdus:currentProduct.cod,idFirma:currentUser.idFirma.id,discount:currentUser.idFirma.discountUG, id:0, comandarepers:[]})
          setUpdatedOrder({tipProdus:currentProduct.cod,idFirma:currentUser.idFirma.id,discount:currentUser.idFirma.discountUG, id:0, comandarepers:[]})
          break;
        case 'pi':
          setCurrentOrder({tipProdus:currentProduct.cod,idFirma:currentUser.idFirma.id,discount:currentUser.idFirma.discountPI, id:0, comandarepers:[]})
          setUpdatedOrder({tipProdus:currentProduct.cod,idFirma:currentUser.idFirma.id,discount:currentUser.idFirma.discountPI, id:0, comandarepers:[]})
          break;
        case 'jo':
          setCurrentOrder({tipProdus:currentProduct.cod,idFirma:currentUser.idFirma.id,discount:currentUser.idFirma.discountJO, id:0, comandarepers:[]})
          setUpdatedOrder({tipProdus:currentProduct.cod,idFirma:currentUser.idFirma.id,discount:currentUser.idFirma.discountJO, id:0, comandarepers:[]})
          break;
        case 'sv':
          setCurrentOrder({tipProdus:currentProduct.cod,idFirma:currentUser.idFirma.id,discount:0, id:0, comandarepers:[]})
          setUpdatedOrder({tipProdus:currentProduct.cod,idFirma:currentUser.idFirma.id,discount:0, id:0, comandarepers:[]})
          break;
        default:
          alert(t('ordersTable.missingProduct'))
      }
      
      setDeletedItems([])
      let path = '/order';
      history.push(path);
    }
    //.....................................
    if (e.item.properties.id==='Modifica'){
      if (masterGrid.current.getSelectedRowIndexes().length){
        await vizualizareComandaSetCurentOrder(orders.filter(com=>(com.id===masterGrid.current.selectionModule.data.id))[0])
        await vizualizareComandaSetUpdatedOrder(orders.filter(com=>(com.id===masterGrid.current.selectionModule.data.id))[0])
        setDeletedItems([])
        setCurrentItem({}) 
        history.push('/order')
      }else{
        enqueueSnackbar(t('ordersTable.noOrderSelected'),{ 
          variant: 'error',
          autoHideDuration:1500
        })
      } 
    }
    //.....................................
    if (e.item.properties.id==='Sterge'){
      if(masterGrid.current.selectionModule.data.stadiu ==='NETRANSMISA'){
        confirmAlert({
          title: t('ordersTable.confirmDeleteTitle'),
          message: t('ordersTable.confirmDeleteMessage'),
          buttons: [
            {
              label: t('common.yes'),
              onClick: async () => {
                document.body.style.cursor = 'wait';
                await strapi.deleteEntry('comandas',masterGrid.current.selectionModule.data.id)
                  .catch(e=>(
                    props.enqueueSnackbar(t('ordersTable.deleteError', { error: e }),{ 
                      variant: 'error',
                      persist:true,  
                    })
                  ))
                  .then(()=>{
                    setOrdersSuccess(orders.filter(order=>(order.id!==masterGrid.current.selectionModule.data.id)))
                    enqueueSnackbar(t('ordersTable.deleteSuccess'),{ 
                      variant: 'success',
                      autoHideDuration:1500
                    })
                    document.body.style.cursor = 'pointer';
                    masterGrid.current.refresh();
                  })
              }
            },
            {
              label: t('common.no'),
              onClick: () => {
                enqueueSnackbar(t('ordersTable.deleteCanceled'),{ 
                  variant: 'warning',
                  autoHideDuration:1500
                })    
              }
            }
          ]
        });
      }else{
        enqueueSnackbar(t('ordersTable.deleteOnlyDraftWarning'),{ 
          variant: 'warning',
        })
      }
    }   
  }
  //----------------------------------------------------------------------------------------------------
  const vizualizareComandaSetCurentOrder=(selectedRow)=>{
    return new Promise( (resolve) => { 
      setTimeout(async() => {
        setCurrentOrder(jsonCopy(selectedRow))
        resolve('ok')
      },50)
    })
  }
  //----------------------------------------------------------------------------------------------------
  const vizualizareComandaSetUpdatedOrder=(selectedRow)=>{
    return new Promise( (resolve) => { 
      setTimeout(async() => {
        setUpdatedOrder(jsonCopy(selectedRow))
        resolve('ok')
      },50)
    })
  }
  //----------------------------------------------------------------------------------------------------
  const vanzatorVizibilitate=()=>{
    if(currentUser.role.name==='Vanzator'){
      return false;
    }else{
      return true;
    }
  }
   
  if (loading===false) {
    return (
      <Card className="control-panel">
        <div className="control-section grid-container">
          {isTableLoading && (
            <div className="grid-overlay">
              <Loader
                color="#00BFFF"
                height={50}
                type="Puff"
                width={50}
              />
            </div>
          )}
          <div className="expo-table-wrapper">
            <div className="expo-search-row">
              <label htmlFor="expo-search-input">{t('expozor.search')}</label>
              <input
                id="expo-search-input"
                className="expo-search-input"
                type="text"
                placeholder={t('expozor.searchPlaceholder')}
                value={searchTerm}
                onChange={handleSearchChange}
              />
            </div>
            <div className="expo-content">
              <div className="expo-carousel">
                <button
                  type="button"
                  className="expo-nav-btn"
                  onClick={() => handleCarouselScroll('up')}
                  disabled={!canScrollUp}
                  aria-label={t('expozor.scrollUp')}
                >
                  ▲
                </button>
                <div className="expo-carousel-list" ref={carouselListRef}>
                  {filteredProducts.length ? (
                    filteredProducts.map((product, index) => (
                      <button
                        key={`${product.Cod || index}-${index}`}
                        type="button"
                        className={`expo-carousel-item ${index === selectedIndex ? 'active' : ''}`}
                        onClick={() => handleSelectProduct(index)}
                      >
                        <span className="expo-item-code">{product.Cod || `#${index + 1}`}</span>
                        {product.imagine ? (
                          <img src={product.imagine} alt={`Expozor ${product.Cod || index + 1}`} />
                        ) : (
                          <div className="expo-placeholder">{t('expozor.noImage')}</div>
                        )}
                      </button>
                    ))
                  ) : (
                    <div className="expo-empty-state">{emptyStateMessage}</div>
                  )}
                </div>
                <button
                  type="button"
                  className="expo-nav-btn"
                  onClick={() => handleCarouselScroll('down')}
                  disabled={!canScrollDown}
                  aria-label={t('expozor.scrollDown')}
                >
                  ▼
                </button>
              </div>
              <div className="expo-detail">
                {selectedProduct ? (
                  <>
                    <div className="expo-detail-card">
                      <div className="expo-detail-media">
                        {selectedProduct.imagine ? (
                          <img src={selectedProduct.imagine} alt={`Imagine ${selectedProduct.Cod}`} />
                        ) : (
                          <div className="expo-placeholder">{t('expozor.noImage')}</div>
                        )}
                      </div>
                      <div className="expo-detail-info">
                        <div className="expo-detail-header">
                          <span className="expo-detail-code-large">{selectedProduct.Cod}</span>
                          <div className="expo-detail-title">
                            <h3>{selectedProduct.Tip || t('expozor.defaultProduct')}</h3>
                          </div>
                        </div>
                        <div className="expo-detail-table">
                          {detailEntries.map(([label, value]) => (
                            <div key={label} className="expo-detail-row">
                              <span className="expo-detail-label">{label}</span>
                              <span className="expo-detail-value">{value}</span>
                            </div>
                          ))}
                        </div>
                        <button
                          type="button"
                          className="expo-add-btn"
                          onClick={handleAddToOrder}
                          disabled={isShortcutLoading}
                        >
                          {isShortcutLoading ? t('expozor.loadingCta') : t('expozor.configureOrderCta')}
                        </button>
                        <div style={{marginTop:'10px',color:'grey', fontSize:'10px', whiteSpace:'pre-line'}}><i>{t('expozor.disclaimer')}</i></div>
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="expo-empty-state">{emptyStateMessage}</div>
                )}
              </div>
            </div>
          </div>
        </div>
      </Card>
    )
  } else {
    return (
      <div className={classes.spinner}>
        <Loader
          color="#00BFFF"
          height={100}
          type="Puff"
          width={100}
        />
      </div>
    );
  }
}

ExpozorTable.propTypes = {
  className: PropTypes.string,
  currentProduct:PropTypes.object,
  currentUser:PropTypes.object,
  loading:PropTypes.bool,
  orders:PropTypes.array
};

const mapStateToProps=state=>({
  currentProduct:selectOrderCurrentProduct(state),
  orders:selectOrderOrders(state),
  currentUser:selectCurrentUser(state),
  loading:selectOtherLoading(state),
})

const mapDispatchToProps=dispatch=>({
  setOrdersSuccess:(orders)=>dispatch(setOrdersSuccess(orders)),
  setCurrentOrder:order=>dispatch(setCurrentOrder(order)),
  setCurrentItem:item=>dispatch(setCurrentItem(item)),
  setUpdatedOrder:order=>dispatch(setUpdatedOrder(order)),
  setDeletedItems:items=>dispatch(setDeletedItems(items)),
  setCurrentProduct:product=>dispatch(setCurrentProduct(product)),
  setExpoPrefill:payload=>dispatch(setExpoPrefill(payload)),
  loadProduseStart:()=>dispatch(loadProduseStart()),
  loadMaterialeStart:()=>dispatch(loadMaterialeStart()),
  loadOptionaleStart:()=>dispatch(loadOptionaleStart()),
  loadCuloriStart:()=>dispatch(loadCuloriStart()),
  loadPreturiTabelareStart:()=>dispatch(loadPreturiTabelareStart()),
  loadInformariStart:()=>dispatch(loadInformariStart()),
  loadIndicatoriStart:()=>dispatch(loadIndicatoriStart()),
})

export default connect(mapStateToProps,mapDispatchToProps)(withRouter(withSnackbar(ExpozorTable)));
